import { ReactNode, useEffect } from "react";
// import { Navigate } from "react-router-dom";
import { usePermissions } from "@quest/hooks/permissions/use-permissions";
import { useAppSelector } from "@quest/hooks";
import { Navigate } from "react-router-dom";

type PermissionScope = "view" | "create" | "edit" | "delete";

function isAllowedForScope(
  perms: ReturnType<typeof usePermissions>,
  resource: string,
  scope: PermissionScope
): boolean {
  switch (scope) {
    case "view":
      return perms.canRead(resource);
    case "create":
      return perms.canCreate(resource);
    case "edit":
      return perms.canUpdate(resource);
    case "delete":
      return perms.canDelete(resource);
    default:
      return false;
  }
}

type RequirePermissionProps = {
  children: ReactNode;
  resource: string;
  /** Defaults to view (read) access */
  scope?: PermissionScope;
  /** When false, access is denied without checking the resource */
  when?: boolean;
};

export function RequirePermission({
  children,
  resource,
  scope = "view",
  when = true,
}: RequirePermissionProps) {
  const perms = usePermissions();
  const allowed = when && isAllowedForScope(perms, resource, scope);

  useEffect(() => {
    if (!allowed) {
      <Navigate to="/admin/forbidden" replace />;
    }
  }, [allowed]);

  // if (!allowed) {
  //   return <Navigate to="/admin/forbidden" replace />;
  // }
  return <>{children}</>;
}

type RequireIslandManagementProps = {
  children: ReactNode;
};

/** Matches admin nav: island time slots only when school uses island assignments and user can view island-management */
export function RequireIslandManagementAccess({
  children,
}: RequireIslandManagementProps) {
  const { uses_island_assignment_structure } = useAppSelector(
    (state) => state.school
  );

  return (
    <RequirePermission
      resource="island-management"
      when={!!uses_island_assignment_structure}
    >
      {children}
    </RequirePermission>
  );
}
